import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { ServiceContactForm } from '../components/ServiceContactForm';
import { CheckCircleIcon } from 'lucide-react';
export function PersonalSupportWorkers() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1057">
      <Navbar data-id="element-1058" />
      <main className="flex-1" data-id="element-1059">
        <ServiceHero badge="Services" title="Personal Support Workers (PSW)" subtitle="Compassionate daily living assistance, personal care, and companionship." imageUrl="https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=1600&auto=format&fit=crop" data-id="element-1060" />

        <div className="max-w-4xl mx-auto px-4 py-16 lg:py-24" data-id="element-1061">
          <div className="prose prose-lg max-w-none text-text-muted leading-relaxed space-y-6" data-id="element-1062">
            <p data-id="element-1063">
              Our Personal Support Workers (PSWs) provide essential daily living
              assistance, personal care, and companionship to individuals in
              various healthcare settings, including long-term care facilities,
              hospitals, and private homes.
            </p>
            <p data-id="element-1064">
              Every PSW on our platform is thoroughly vetted,
              background-checked, and insured. They are trained to assist with
              bathing, grooming, mobility, meal preparation, and social
              engagement, ensuring patients receive compassionate and dignified
              care.
            </p>
          </div>

          <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-1065">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-1066">
              PSW Core Competencies
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1067">
              {['Assistance with bathing, grooming & hygiene', 'Mobility support & safe transfers', 'Meal preparation & feeding assistance', 'Companionship & social engagement', 'Vitals monitoring & reporting', 'Fully background-checked & insured'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-1068">
                  <CheckCircleIcon className="w-6 h-6 text-accent-teal flex-shrink-0 mt-0.5" data-id="element-1069" />
                  <span className="text-text-dark font-medium" data-id="element-1070">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <ServiceContactForm serviceName="Personal Support Workers (PSW)" data-id="element-1071" />
      </main>
      <StickyFooter data-id="element-1072" />
    </div>;
}